import { render, staticRenderFns } from "./DecimalEditor.vue?vue&type=template&id=645bbdad"
import script from "./DecimalEditor.vue?vue&type=script&lang=js"
export * from "./DecimalEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports